//@state
export interface authState {
  currentCourse: any;
  preRegisterCode: null;
  hasNationalCode: false;
  nationalCodePreview: null;
  parvandehInfo: any;
  extraFields: null;
}

export const initialState: authState = {
  currentCourse: {},
  preRegisterCode: null,
  hasNationalCode: false,
  nationalCodePreview: null,
  parvandehInfo: {},
  extraFields: null,
};
